const addMinutesToDate = (objDate: Date, minute: number) => {
  const numberOfMlSeconds = objDate.getTime();
  const addMlSeconds = minute * 60 * 1000;
  const newDateObj = new Date(numberOfMlSeconds + addMlSeconds);
  return newDateObj;
};

export default addMinutesToDate;
